import { useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Spinner,
} from "reactstrap";
import { XCircle, Plus, Edit2 } from "react-feather";

import { getDropdownOptions } from "../../static/brands_wholesalers_data";
import DataTable from "react-data-table-component";
import DropDownSelectFromList from "../../CommonElements/DropDownSelectFromList";
import { updateRetailer as updateRetailerDataAction } from "../../ReduxToolkit/Reducers/retailers";

const RetailerExpandedTableRow = ({
  data,
  userPermissions,
  updateRetailerData
}) => {
  const [isRowEditing, setIsRowEditiing] = useState(false);
  // const isAdmin = userPermissions?.admin_access || true;
  const isEditPermission = userPermissions?.edit || true;
  const [editingCell, setEditingCell] = useState("");

  // State for various brand attributes
  const [market, setMarket] = useState(data?.country ? [data?.country] : []);
  const [preferred_market, setPreferredMarket] = useState(data?.preferred_market || []);
  const [product_category, setProductCategory] = useState(data?.product_category || []);
  const [target_group, setTargetGroup] = useState(data?.target_group || []);
  const [style, setStyle] = useState(data?.style || []);
  const [age, setAge] = useState(data?.age || []);
  const [price, setPrice] = useState(data?.price || []);
  const [loading, setLoading] = useState(false);

  const handleDropdownSelect = (selectedOption, listType) => {
    switch (listType) {
      case "market": {
        setMarket([selectedOption]);
        break;
      }
      case "preferred_market": {
        let filteredPreferredMarkets = selectedOption !== "Open" ? preferred_market?.filter((v) => v !== "Open") : [];
        setPreferredMarket([...filteredPreferredMarkets, selectedOption]);
        break;
      }
      case "product_category": {
        setProductCategory([...product_category, selectedOption]);
        break;
      }
      case "target_group": {
        setTargetGroup([...target_group, selectedOption]);
        break;
      }
      case "style": {
        setStyle([...style, selectedOption]);
        break;
      }
      case "age": {
        setAge([...age, selectedOption]);
        break;
      }
      case "price": {
        setPrice([...price, selectedOption]);
        break;
      }
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    await updateRetailerData({
      data: {
        id: data?.id,
        features: {
          age: age,
          price: price,
          style: style,
          country: market?.length ? market[0] : 'N/A',
          // preferred_market: preferred_market,
          target_group: target_group,
          product_category: product_category,
        },
      },
      cb: () => {
        setIsRowEditiing(false);
      },
    });
    setLoading(false);
  };

  // Render methods for repeated cells
  const renderMultiSelectCell = (
    items,
    listType,
    setItems,
    dropdownOptions,
    renderFirstItemOnly = true
  ) => {
    const displayItems = items

    return (
      <div className="d-flex flex-column align-items-start pt-2">
        {displayItems.map((item, i) => (
          <div
            key={i}
            className="d-flex justify-content-between align-items-center border rounded p-1 mb-2"
            style={{ maxWidth: "110px", minWidth: '100px', width: "100%" }}
          >
            <span className="text-truncate text-muted" style={{ fontSize: "13px" }}>
              {item}
            </span>
            {isEditPermission && isRowEditing && (
              <Button
                size="sm"
                color='black'
                className="p-0"
                onClick={() => setItems(items.filter((p) => p !== item))}
              >
                <XCircle size={18} color='#999' />
              </Button>
            )}
          </div>
        ))}

        {isEditPermission && isRowEditing ? (
          editingCell === listType ? (
            <DropDownSelectFromList
              data={getDropdownOptions(listType, true)}
              values={items}
              onValueSelect={(val) => handleDropdownSelect(val, listType)}
            />
          ) : (
            <Button
              color="black"
              className="mx-auto d-flex align-items-center gap-1"
              onClick={() => setEditingCell(listType)}
            >
              <Plus size={20} color="#999" />
            </Button>
          )
        ) : null}
      </div>
    );
  };

  return (
    <div className="table-responsive">
      <DataTable
        noHeader
        noTableHead
        expandableRows={true}
        expandableRowDisabled={() => true}
        expandableIcon={<div />}
        data={[data]}
        columns={[
          {
            name: "Options",
            cell: row => (
              <button className="btn" onClick={() => setIsRowEditiing((prev) => !prev)}>
                <Edit2 size={20} color="#999" />
              </button>
            ),
            sortable: false,
            center: true,
          },
          {
            name: "Brands",
            sortable: true,
            center: false,
          },
          {
            name: "Company",
            sortable: true,
            center: false,
            width: '200px'
          },
          {
            name: "Location",
            cell: () => renderMultiSelectCell(market, "market", setMarket, getDropdownOptions("market", true), false),
            center: false,
          },
          // {
          //   name: "Preferred Market",
          //   cell: () => renderMultiSelectCell(preferred_market, "preferred_market", setPreferredMarket, getDropdownOptions("preferred_market", true), false),
          //   center: false,
          // },
          {
            name: "Target Group",
            cell: () => renderMultiSelectCell(target_group, "target_group", setTargetGroup, getDropdownOptions("target_group", true), false),
            center: false,
          },
          {
            name: "Product Category",
            cell: () => renderMultiSelectCell(product_category, "product_category", setProductCategory, getDropdownOptions("product_category", true), false),
            center: false,
          },
          {
            name: "Product Style",
            cell: () => renderMultiSelectCell(style, "style", setStyle, getDropdownOptions("style", true), false),
            center: false,
          },
          {
            name: "Age group",
            cell: () => renderMultiSelectCell(age, "age", setAge, getDropdownOptions("age", true), false),
            center: false,
          },
          {
            name: "Price Range",
            cell: () => renderMultiSelectCell(price, "price", setPrice, getDropdownOptions("price", true), false),
            center: false,
          },
        ]}
      />
      <DataTable
        noHeader
        noTableHead
        expandableRows={true}
        expandableRowDisabled={() => true}
        expandableIcon={<div />}
        data={[data]}
        columns={[
          {
            name: "Brands",
            sortable: true,
            center: false,
          },
          {
            name: "Wholesale group",
            center: false,
            width: '200px'
          },
          {
            name: "Location",
            center: false,
          },
          // {
          //   name: "Preferred Market",
          //   center: false,
          // },
          {
            name: "Target Group",
            center: false,
          },
          {
            name: "Product Category",
            center: false,
          },
          {
            name: "Product Style",
            center: false,
          },
          {
            name: "Age group",
            center: false,
          },
          {
            name: "Price Range",
            center: false,
          },
          {
            name: "Options",
            cell: row => (
              <Button color="primary" disabled={loading} onClick={handleSubmit}>
                {loading && <Spinner size='sm' style={{ marginRight: '10px' }} />}
                Save
              </Button>
            ),
            sortable: false,
            center: false,
          },
        ]}
      />
    </div>
  );
};

const mapDispatchToProps = {
  updateRetailerData: updateRetailerDataAction,
};

const mapStateToProps = (state) => ({
  // userPermissions: selectUser(state)?.permissions?.brands_showrooms,
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailerExpandedTableRow);